<template>

	<div class="login-redirect">
		<b-row class="justify-content-center">
			<b-col sm="10" class="text-center mb-50">
				<h1>Hereinspaziert!</h1>
				<h5>Melde dich hier mit deinen Benutzerdaten an und trete ein in die aufregende Welt des McDonald’s&nbsp;Junior&nbsp;Clubs!</h5>
			</b-col>
		</b-row>
		<b-row class="justify-content-center">
			<b-col sm="8" lg="5">
				<loginComponent />
			</b-col>
		</b-row>


	</div>

</template>
<style lang="scss">
	@import '../styles/views/login-redirect';
</style>
<script>
	import loginComponent from '../components/login.vue';

	export default {
		name: 'loginView',
		components: {
			loginComponent
		},
		data() {
			return {
				userIsLoggedIn: this.$store.state.loggedIn
			};
		}
	};
</script>
